import { InternalPage, MediaAsset, Sys } from 'libs/contentful/props';
import Link, { LinkProps } from '../Link/Link';
import ChimeKitIcon from './ChimeKitIcon';
import Media from '../Media/Media';

interface LinkWithIconComponentProps extends LinkProps {
  href?: string;
  chimeKitIconName?: string;
  icon?: MediaAsset;
  internalPage?: InternalPage;
  sys?: Sys;
}

const LinkWithIcon = ({
  children,
  href,
  chimeKitIconName,
  icon,
  internalPage,
  className,
  ...props
}: LinkWithIconComponentProps) => {
  const hasValidIcon = icon?.url;
  const showChimeKitIcon = chimeKitIconName != null && !hasValidIcon;

  return (
    <Link href={href} internalPage={internalPage} className={className} {...props}>
      <div className="flex gap-2">
        {(showChimeKitIcon || hasValidIcon) && (
          <div className="w-6 flex-none" aria-hidden="true">
            {showChimeKitIcon && <ChimeKitIcon iconName={chimeKitIconName} />}
            {hasValidIcon && <Media media={{ ...icon, width: 24, height: 24 }} className="w-full" />}
          </div>
        )}
        {children}
      </div>
    </Link>
  );
};

export default LinkWithIcon;
